export default __webpack_public_path__ + "static/cianorte-a78fc6d0f6d90effa0a6c756fd591f3c.png";